import { render } from "./COIActionBarUnfreezeOrder.vue?vue&type=template&id=6d09213e"
import script from "./COIActionBarUnfreezeOrder.vue?vue&type=script&lang=js"
export * from "./COIActionBarUnfreezeOrder.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__